import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CopyDialogComponent } from '../../../../copy-dialog/copy-dialog.component';
import { RightBridgeApiService } from '../../../../services/right-bridge-api.service';
import { Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-clone-case',
  templateUrl: './clone-case.component.html',
  styleUrls: ['./clone-case.component.scss'],
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, MatMenuModule],
})
export class CloneCaseComponent {
  @Input() donorCase;
  @Input() rights;
  @Output() toggleLoading = new EventEmitter();

  private rbs = inject(RightBridgeApiService);
  private route = inject(Router);
  private snacky = inject(MatSnackBar);
  dialog = inject(MatDialog);

  cloneCase() {
    let dialogRef = this.dialog.open(CopyDialogComponent, {
      panelClass: 'copy-dialog',
      data: {
        headline: 'Copy Profile',
        rights: this.rights,
        item: this.donorCase,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data && result.data !== 'cancel') {
        const desc = result.data;
        this.toggleLoading.emit(true);
        this.rbs.copyProfile(this.donorCase.profileId, desc).subscribe({
          next: x => {
            const id = x?.['results'] ?? x?.result;
            if (typeof id !== 'string' || !id.trim()) {
              this.snacky.open(
                'Oops! Something went wrong. Please try again.',
                'Close',
                { duration: 4000 }
              );
              this.toggleLoading.emit(false);
              return;
            }

            const app =
              result['app'] === 'pp' || !result['app'] ? 'rb' : result['app'];
            this.route.navigate([`/case/${app}/${id}/0`]);
            this.toggleLoading.emit(false);
          },
          error: () => {
            this.snacky.open(
              'Oops! Something went wrong. Please try again.',
              'Close',
              { duration: 4000 }
            );
            this.toggleLoading.emit(false);
          },
        });
      }
      dialogRef = null;
    });
  }
}
